import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ShoppingCart = createReactComponent("ShoppingCart", ["svg", defaultAttributes, [["circle", {
  cx: "9",
  cy: "21",
  r: "1",
  key: "n6kcle"
}], ["circle", {
  cx: "20",
  cy: "21",
  r: "1",
  key: "ccb8gp"
}], ["path", {
  d: "M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6",
  key: "16805q"
}]]]);
export default ShoppingCart;